import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=0910e162&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=0910e162&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0910e162"]])

export default __exports__